import { StatusPill, StatusPillProps } from "components/shared/pills/StatusPill";

type GrayStatusPillProps = StatusPillProps;

export const GrayStatusPill = (props: GrayStatusPillProps) => {
  return (
    <StatusPill {...props} textColor="text-gray-800" backgroundColor="bg-gray-100" iconBackgroundColor="bg-gray-500" />
  );
};
